import z from "zod";
import { LabelIdSchema } from "./idTypes";
import { TenancySchema } from "./tenancyTypes";
import { AuditMetaSchema } from "./auditMetaTypes";

export const LabelSchema = z
  .object({
    id: LabelIdSchema,
    name: z.string(),
    description: z.string(),
    icon: z.string(),
    color: z.string(),
    scope: z.string(),
    usageCount: z.number(),
    lastUsedAt: z.string().optional().nullable(),
  })
  .extend(TenancySchema.shape)
  .extend(AuditMetaSchema.shape);
export type Label = z.infer<typeof LabelSchema>;
